import React from 'react';
import { Chip, Box } from '@mui/material';
import ProfilePic from '../../../../components/Common/ProfilePic';

const ReusableChip = ({
	user,
	handleDelete,
	labelStyles,
	avatarStyles,
	chipHeight = '24px'
}) =>
{
	return (
		<Chip
			avatar={
				<Box display='inline-flex'>
					<ProfilePic
						imagePath={`${user?.userId}.jpeg`}
						defaultImg='/images/icons/defaultUser.svg'
						alt='profilepic'
						className='brdrRadius50'
						from='selfProfile'
					/>
				</Box>
			}
			label={user?.name}
			sx={{
				'&& .MuiChip-label' : {
					maxWidth : 'var(--font120)',
					fontSize : '12px',
					...labelStyles
				},
				'&& .MuiChip-avatar' : {
					width  : '18px',
					height : '18px',
					...avatarStyles
				},
				height : chipHeight
			}}
			variant='outlined'
			onDelete={() => handleDelete(user?.userId)}
		/>
	);
};

export default ReusableChip;
